import React from 'react';
import { observer } from 'mobx-react-lite';
import { PasswordGeneratorUI } from '../features/password-generator/ui/password-generator-ui';

export const PasswordGeneratorObserver: React.FC = observer(() => {
  return <PasswordGeneratorUI />;
});
